import React from 'react'
import { Flex, Heading } from '@chakra-ui/react'
import { useDeviceType } from 'app/hooks';

const PersonalDetailsHeader = () => {
  const { isMobile } = useDeviceType();
  return (
    <Flex justifyContent="space-between" px={isMobile ? 6 : 10} py={isMobile ? '4' : '5'} alignItems="center">
      <Heading fontWeight="bold" size={isMobile ? 'sm' : 'md'}>
        Personal Details
      </Heading>
      {/* <Flex flexDirection="column" alignItems="flex-end">
        <Heading color="#366B9E" size="sm">
          48 hrs 25 min left
        </Heading>
        <Text fontSize="sm">Before you can appear in the exam</Text>
      </Flex> */}
    </Flex>
  )
}

export default PersonalDetailsHeader
